// External libraries
import gql from 'graphql-tag';

export const PP_WORLD_WALLET_OPTIONS_QUERY = gql`
  query PPWorldWalletOptionsQuery(
    $token: String!
    $buyerCountry: CountryCodes!
    $locale: LocaleInput!
  ) {
    ppWorldWalletOptions(
      token: $token
      buyerCountry: $buyerCountry
      locale: $locale
    ) {
      __typename
      isEligible
      connectedByLabel
      payPalWorldWalletsLabel
      payPalWorldLogoUrl {
        href
      }
      checkoutOptions {
        __typename
        id
        name
        label
        logoUrl {
          href
        }
        redirectUrl {
          href
        }
      }
    }
  }
`;
